export const formatCurrency = (amount: number, locale = 'en-US', currency = 'USD'): string => {
  return new Intl.NumberFormat(locale, {
    currency,
    style: 'currency',
  }).format(amount);
};
